import axios from 'axios';

import appSettings from '../app-settings';

const DESIGNATIONS_URL = `${appSettings.baseUrl}/donations/designations`;

export const getDesignations = async () => {
  const res = await axios.get(DESIGNATIONS_URL);
  return res.data;
};

export const createDesignation = async (data) => {
  const res = await axios.post(DESIGNATIONS_URL, data);
  return res.data;
};

export const updateDesignation = async (designationId, data) => {
  const res = await axios.patch(`${DESIGNATIONS_URL}/${designationId}`, data);
  return res.data;
};

export const deleteDesignation = async (designationId) => {
  await axios.delete(`${DESIGNATIONS_URL}/${designationId}`);
};
